import { render, staticRenderFns } from "./customer_authentication_notice.vue?vue&type=template&id=6cb39851&"
import script from "./customer_authentication_notice.vue?vue&type=script&lang=js&"
export * from "./customer_authentication_notice.vue?vue&type=script&lang=js&"
import style0 from "./customer_authentication_notice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports